module.exports = __webpack_public_path__ + "img/certificate.35b242f2.png";